import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { EditorState, RichUtils } from 'draft-js';
import { getEditorStateSnapshot } from '../index';

var addLink = function addLink(editorState, linkEntityTypeAndData) {
  var _getEditorStateSnapsh = getEditorStateSnapshot(editorState),
      selectedText = _getEditorStateSnapsh.selectedText;

  var contentState = editorState.getCurrentContent();
  var contentStateWithEntity = contentState.createEntity(linkEntityTypeAndData.type, 'MUTABLE', _objectSpread(_objectSpread({}, linkEntityTypeAndData.data), {}, {
    selectedText: selectedText
  }));
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var newEditorState = EditorState.set(editorState, {
    currentContent: contentStateWithEntity
  });
  return RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), entityKey);
};

export default addLink;